import { TFunction } from 'i18next';
import { Heart } from 'shared/assets/icons';
import { FilterOptionType, FilterSelectOption } from 'shared/types/filter';
import { FilterOptionKeys } from 'shared/types/filter-document';
import { LifeArea } from 'shared/types/life-area';
import { lifeAreaOtherID } from 'shared/types/orderable-section';

export type Options = {
  t: TFunction;
};

export const createLifeAreaFilter = (
  lifeAreas: LifeArea[],
  { t }: Options,
): FilterSelectOption[] =>
  lifeAreas.length
    ? [
        {
          id: FilterOptionKeys.LifeArea,
          label: t('context-menus.filtering.task.filters.life-areas.title'),
          placeholder: t('general.labels.select'),
          icon: Heart,
          type: FilterOptionType.MultiSelect,
          selectOptions: [
            ...lifeAreas.map((lifeArea) => ({
              label: lifeArea.name,
              value: lifeArea.id,
            })),
            {
              label: t('general.sections.life-areas.other.title'),
              value: lifeAreaOtherID,
            },
          ],
          canReset: true,
          enableSearch: true,
        },
      ]
    : [];
